import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SweetAlertService } from 'src/app/core/services/sweet-alert/sweet-alert.service';
import { ChilexpressService } from '../../../core/services/chilexpress/chlexpress.service';

@Component({
  selector: 'app-escanear-qr2',
  templateUrl: './escanear-qr2.component.html',
  styleUrls: ['./escanear-qr2.component.scss']
})
export class EscanearQr2Component implements OnInit {

  constructor(private ChilexpressService:ChilexpressService, private router: Router, private sweetAlertService: SweetAlertService) { }
  datosprc;
  DatosConfig = {};
  ngOnInit(): void {
    this.datosprc = {};
    this.CrearCabeceraCarro();
  }

  identificacionManual()
  {
    this.router.navigate(['identManual']);
  }

  lecturaCorrecta()
  {
    this.router.navigate(['qrEscaneado2']);
  }

  async CrearCabeceraCarro() {
    this.DatosConfig = await this.ChilexpressService.GetConfig();
    var crearcarro = {
      "carro": {
        "idCarro": 0,
        "idPortador": 0,
        "tipoOperacion": 1,
        "codOficina": this.DatosConfig["CodOfilocal"],
        "estado": 1,
        "registroGrabacion": "",
        "folioRetiro": 0
      }
    }
    var respcar = await this.ChilexpressService.crearCabeceraCarro(crearcarro);
    //console.log(respcar);
    
    if (respcar["status"] == true) {
      this.datosprc["idcarro"] = respcar["data"][0]["idCarro"];
      //console.log(this.datosprc);
      localStorage.setItem("datosproc",JSON.stringify(this.datosprc));

    }
  }




}
